import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowAltCircleLeft, faChevronCircleLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  PageContainer,
  SectionTitle,
  Button,
  Table,
  TableCell,
  TableHeader,
  TableFormGroup,
  Divider,
  TableRow,
  fadeIn,
  Footer,
  useGoBack,
  FormRow, FormGroup, Label, Input, FormRowFull, Toggle, ToggleInput,
  Card,
  CardTitle,
  CardContent,
  SubSectionTitle
} from '../styles/PageStyles';
import { createDataSource, getAllDataSourcesByFilter, getDataSources, updateDataSource } from '../services/dataSourceService';
import { getAllConnectorsByFilter } from '../services/connectorService';
import CommonHexagonBadge from '../components/common/CommonHexagonBadge';
import toastService from '../services/toastService';
import { usePermission } from '../context/PermissionContext';


const DataSourceDetails = () => {
  const { dsId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [connectorList, setconnectorList] = useState();
  const [dataSourceDetail, setDataSourceDetail] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const basePath = process.env.PUBLIC_URL || "";

  const { permissions, permissionEnum, loading } = usePermission();
  
  
  const userAccessPermissions = permissions?.length
      ? permissions
        .filter(ele => ele.component_type === "data_source")
        .map(ele => ele.permission)
      : [];



  // For DataSource Current
  useEffect(() => {
    const fetchDataSourceByCode = async () => {
      try {
        const parseddsId = (dsId); // Parse entityId as a number

        let filter = {
          "code": parseddsId
        }
        const response = await getDataSources(filter, {});
        setDataSourceDetail({
          ...response[0]
        });

      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchConnectorData();
    if (dsId !== 'new') {
      fetchDataSourceByCode();
    } else {
      if (user) {
        setDataSourceDetail({
          code: "DS-" + new Date().getTime(),
          company_cd: user.companyCd,
          name: "",
          status: "ACTIVE",
          connector: "",
          description: ""
        });
      }
    }

  }, [dsId, user]);

  const fetchConnectorData = async () => {
    try {
      const response = await getAllConnectorsByFilter();
      setconnectorList(response)
    } catch (error) {
      console.error("cannot fetch connector")
    }
  };

  const getAttribType = (type) => {
    switch (type) {
      case 'STR':
        return 'String';
      case 'INT':
        return 'Integer';
      case 'FLOAT':
        return 'Float';
      case 'DATE':
        return 'Date';
      case 'ENTITY':
        return 'Entity';
      default:
        return type;
    }
  }
  const goBack = useGoBack();

  const saveDataSource = () => {
    try {
      if (dataSourceDetail.id) {
        updateDataSource(dataSourceDetail);
      } else {
        createDataSource(dataSourceDetail);
      }
      toastService.success('DataSource updated successfully.')
      navigate('/data-sources');
    } catch (error) {
      console.error('Error saving DataSource:', error);

    }
  }

  const filteredProperties = dataSourceDetail?.data
    ? Object.keys(dataSourceDetail.data)
      .filter((key) =>
        key.toLowerCase().includes(searchTerm?.toLowerCase())
      )
      .map((key) => ({
        key,
        value: dataSourceDetail.data[key],
      }))
    : [];


  const addRemoveAttribute = (index) => {
    if (typeof index === 'number') {
      // Remove the attribute at the specified index
      const updatedData = { ...dataSourceDetail.data };
      const keyToRemove = filteredProperties[index].key;
      delete updatedData[keyToRemove];
      setDataSourceDetail({ ...dataSourceDetail, data: updatedData });
    } else {
      // Add a new attribute with a default key-value pair
      const newKey = `newKey${Object.keys(dataSourceDetail.data).length + 1}`;
      setDataSourceDetail((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          [newKey]: "", // Add a new key with an empty value
        },
      }));
    }
  };

  const handleAddDataSource = (conn) => {
    setDataSourceDetail((prev) => {
      const updatedData = { ...prev.data }; // Clone the existing data object

      // Add missing keys from connector.properties
      conn.properties?.forEach((property) => {
        if (!(property in updatedData)) {
          updatedData[property] = ''; // Add the missing key with an empty value
        }
      });

      return {
        ...prev,
        connector: conn.code, // Set the selected connector
        data: updatedData, // Update the data object
      };
    });
  }





  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <SectionTitle>
          <Button onClick={goBack} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
          {dataSourceDetail?.name ? (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              {dataSourceDetail?.name}
            </span>
          ) : (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              Add DataSource
            </span>
          )}
        </SectionTitle>
        <Divider />
        <FormRow>
          <FormGroup>
            <Label>Name</Label>
            <Input type="text" value={dataSourceDetail?.name || ''} onChange={(e) => setDataSourceDetail({ ...dataSourceDetail, name: e.target.value })} />
          </FormGroup>
        </FormRow>
        <FormRowFull>
          <FormGroup>
            <Label>Description</Label>
            <Input type="text" value={dataSourceDetail?.description || ''} onChange={(e) => setDataSourceDetail({ ...dataSourceDetail, description: e.target.value })} />
          </FormGroup>
        </FormRowFull>

        <div>
          <SectionTitle>Available Connectors</SectionTitle>
          <Divider />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            {connectorList?.map((conn, index) => (

              <Card key={index} style={{
                width: '100%', padding: '1rem', marginTop: '1rem',
                border: dataSourceDetail?.connector === conn.code ? '2px solid #007bff' : '1px solid #ccc', // Highlight selected connector
                backgroundColor: dataSourceDetail?.connector === conn.code ? '#e7f3ff' : '#fff', // Change background color for selected connector
                transition: 'all 0.3s ease', // Smooth transition for styling changes
              }}
              >
                <CardTitle>
                  <CommonHexagonBadge
                    stroke="stroke-brand-clarity"
                    fill="fill-brand-light"
                    size="size-[50px]"
                    iconImage={`${basePath}/assets/images/connectors/${conn.code}.png`}
                    style={{ cursor: 'pointer' }}
                  />
                  <div style={{ cursor: 'pointer' }}>
                    <h5>Data Source: {conn.name}</h5>
                    <p>{conn.description}</p>
                  </div>
                  <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>

                    {
                      (userAccessPermissions.includes(permissionEnum.CREATE) || userAccessPermissions.includes(permissionEnum.UPDATE)) && (
                        <Button
                          style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}
                          onClick={() => handleAddDataSource(conn)}
                        >
                          <FontAwesomeIcon icon={faPlus} /> Add
                        </Button>
                      )
                    }

                  </div>
                </CardTitle>
              </Card>


            ))}
          </div>
        </div>
        <Divider />
        <SubSectionTitle>Properties</SubSectionTitle>
        <Table>
          <thead>
            <tr>
              <TableHeader>Name</TableHeader>
              <TableHeader>Value</TableHeader>
              <TableHeader>

                {
                  (userAccessPermissions.includes(permissionEnum.CREATE) || userAccessPermissions.includes(permissionEnum.UPDATE)) && (
                    <Button
                      onClick={() => addRemoveAttribute()}
                      style={{ padding: "0.3rem 0.6rem", fontSize: "0.8rem" }}
                    >
                      <FontAwesomeIcon icon={faPlus} />Add Property
                    </Button>
                  )
                }

              </TableHeader>
            </tr>
          </thead>
          <tbody>
            {filteredProperties.map((attrib, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TableFormGroup>
                    <Input
                      type="text"
                      value={attrib.key || ""}
                      onChange={(e) => {
                        const updatedData = { ...dataSourceDetail.data };
                        const oldKey = attrib.key;
                        const newKey = e.target.value;

                        // Update the key in the data object
                        updatedData[newKey] = updatedData[oldKey];
                        delete updatedData[oldKey];

                        setDataSourceDetail({ ...dataSourceDetail, data: updatedData });
                      }}
                    />
                  </TableFormGroup>
                </TableCell>
                <TableCell>
                  <TableFormGroup>
                    <Input
                      type="text"
                      value={attrib.value || ""}
                      onChange={(e) => {
                        const updatedData = { ...dataSourceDetail.data };
                        updatedData[attrib.key] = e.target.value;
                        setDataSourceDetail({ ...dataSourceDetail, data: updatedData });
                      }}
                    />
                  </TableFormGroup>
                </TableCell>
                <TableCell>
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <Button
                      onClick={() => addRemoveAttribute(index)}
                      style={{
                        padding: "0.3rem 0.6rem",
                        fontSize: "0.8rem",
                        color: "white",
                        backgroundColor: "#ff4444",
                        borderColor: "#ff4444",
                      }}
                    >
                      Remove
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </tbody>
        </Table>
        <Footer>
          <div style={{ flex: '1' }}></div>
          {
            (userAccessPermissions.includes(permissionEnum.CREATE) || userAccessPermissions.includes(permissionEnum.UPDATE)) && <Button primary onClick={() => saveDataSource()}>
              <FontAwesomeIcon icon={faSave} /> Save DataSource</Button>
          }
        </Footer>




      </motion.div>

    </PageContainer>
  );
}

export default DataSourceDetails;